export class SealedWebSocket {
  private ws: WebSocket

  constructor(
    ws: WebSocket,
    onOpen: WebSocket['onopen'],
    onMessage: WebSocket['onmessage'],
    onClose: WebSocket['onclose'],
    onError: WebSocket['onerror']
  ) {
    this.ws = ws
    this.ws.onopen = onOpen
    this.ws.onclose = onClose
    this.ws.onmessage = onMessage
    this.ws.onerror = onError
  }

  public send(...args: Parameters<WebSocket['send']>): void {
    this.ws.send(...args)
  }

  public sendJSON(...args: Parameters<typeof JSON.stringify>): void {
    this.ws.send(JSON.stringify(...args))
  }

  public close(): void {
    this.ws.close()
  }

  get isOpened(): boolean {
    return this.ws.readyState === WebSocket.OPEN
  }
}
